import { Link as RouterLink } from "react-router-dom";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { FaArrowRight } from "react-icons/fa6";
import ParticleCanvas from "../../../login/components/ParticleCanvas";

const ACCENT = "#04aec1";
const ACCENT_MID = "#6366f1";

const AboutFinalCta = () => (
  <Box
    as="section"
    position="relative"
    overflow="hidden"
    bg={`linear-gradient(160deg, ${ACCENT}, ${ACCENT_MID})`}
    px={{ base: "20px", md: "28px" }}
    py={{ base: "72px", md: "96px" }}
    color="white"
    textAlign="center"
  >
    <Box
      position="absolute"
      inset={0}
      pointerEvents="none"
      sx={{
        backgroundImage: "url('/navbar_bg.png')",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        opacity: 0.4,
        mixBlendMode: "screen",
      }}
    />
    <ParticleCanvas tint="#ffffff" density={0.9} link={130} />
    <Box
      position="absolute"
      inset={0}
      pointerEvents="none"
      sx={{
        background:
          "radial-gradient(ellipse at 50% 50%, rgba(0,0,0,0.18), transparent 60%)",
      }}
    />

    <Box position="relative" zIndex={2} maxW="720px" mx="auto">
      <Heading
        as="h2"
        m={0}
        fontSize={{ base: "30px", md: "40px", lg: "48px" }}
        fontWeight={700}
        letterSpacing="-0.025em"
        lineHeight="1.1"
        sx={{ textShadow: "0 2px 12px rgba(0,0,0,0.18)" }}
      >
        See your retailer feeds the Spear way.
      </Heading>
      <Text
        mt="18px"
        mb={0}
        fontSize={{ base: "15px", md: "17px" }}
        color="rgba(255,255,255,0.88)"
        lineHeight="1.55"
      >
        30 minutes. Your real data. No slide deck. We'll show you exactly what
        Spearbi will surface for your brand.
      </Text>

      <Flex mt="28px" gap="12px" justify="center" wrap="wrap">
        <Box
          as={RouterLink}
          to="/contact-us"
          display="inline-flex"
          alignItems="center"
          gap="8px"
          px="24px"
          py="14px"
          borderRadius="9999px"
          bg="white"
          color="#0a0e1a"
          fontSize="14px"
          fontWeight={700}
          textDecoration="none"
          boxShadow="0 12px 30px -10px rgba(0,0,0,0.3)"
          transition="transform .2s ease, box-shadow .2s ease"
          _hover={{
            transform: "translateY(-1px)",
            boxShadow: "0 14px 32px -10px rgba(0,0,0,0.35)",
            textDecoration: "none",
          }}
        >
          Book a demo
          <FaArrowRight size={12} />
        </Box>
        <Box
          as={RouterLink}
          to="/signin"
          display="inline-flex"
          alignItems="center"
          padding="14px 24px"
          borderRadius="9999px"
          bg="rgba(255,255,255,0.12)"
          color="white"
          border="1px solid rgba(255,255,255,0.25)"
          fontSize="14px"
          fontWeight={600}
          textDecoration="none"
          backdropFilter="blur(10px)"
          transition="background .2s ease"
          _hover={{
            bg: "rgba(255,255,255,0.18)",
            textDecoration: "none",
          }}
        >
          Already a customer? Sign in
        </Box>
      </Flex>
    </Box>
  </Box>
);

export default AboutFinalCta;
